export enum Locale {
  // keeping alphabetical order in English for now
  en_US = 'en_US',
  zh_CN = 'zh_CN',
  de_DE = 'de_DE',
  es_ES = 'es_ES',
  es_LA = 'es_LA',
  fr_FR = 'fr_FR',
  he_IL = 'he_IL',
  it_IT = 'it_IT',
  ja_JP = 'ja_JP',
  ko_KR = 'ko_KR',
  nl_NL = 'nl_NL',
  pt_BR = 'pt_BR',
  ru_RU = 'ru_RU',
  tr_TR = 'tr_TR',
  uk_UA = 'uk_UA',
}

interface Hash {
  [name: string]: string;
}

export const LocaleText: Hash = {
  [Locale.en_US]: 'English',
  [Locale.de_DE]: 'Deutsch',
  [Locale.es_ES]: 'Español (España)',
  [Locale.es_LA]: 'Español (América Latina)',
  [Locale.fr_FR]: 'Français',
  [Locale.he_IL]: 'עברית',
  [Locale.it_IT]: 'Italiano',
  [Locale.ko_KR]: '한국어',
  [Locale.ja_JP]: '日本語',
  [Locale.pt_BR]: 'Português',
  [Locale.ru_RU]: 'Русский',
  [Locale.tr_TR]: 'Türkçe',
  [Locale.zh_CN]: '中文',
  [Locale.uk_UA]: 'Українська',
  [Locale.nl_NL]: 'Nederlands',
};

export const LocaleFlag: Hash = {
  [Locale.en_US]: 'united-states.png',
  [Locale.de_DE]: 'germany.png',
  [Locale.es_ES]: 'spain.png',
  [Locale.es_LA]: 'spain.png',
  [Locale.fr_FR]: 'france.png',
  [Locale.he_IL]: 'israel.png',
  [Locale.it_IT]: 'italy.png',
  [Locale.ja_JP]: 'japan.png',
  [Locale.ko_KR]: 'korean.png',
  [Locale.pt_BR]: 'portugal.png',
  [Locale.ru_RU]: 'russia.png',
  [Locale.tr_TR]: 'turkey.png',
  [Locale.zh_CN]: 'china.png',
  [Locale.uk_UA]: 'ukraine.png',
  [Locale.nl_NL]: 'netherlands.png',
};

export function fixLocale(loc: string): string {
  loc = loc || '';

  const locParts = loc.split('_');

  if (locParts.length !== 2) {
    return loc;
  }

  return `${locParts[0].toLowerCase()}_${locParts[1].toUpperCase()}`;
}
